import { Stack, Typography, Divider, TableCell, TableCellProps, Theme, SxProps } from "@mui/material";


export type HeaderCellProps = {
    text: string;
    hideDivider?: boolean,
    sx?: SxProps<Theme>
} & TableCellProps;

export function HeaderCell({
    text,
    hideDivider,
    sx,
    ...rest
}: HeaderCellProps) {


    return (
        <TableCell component='th' {...rest} sx={{paddingRight: 0, ...sx}}>
            <Stack direction='row' >
                <Typography variant="body2" sx={{
                    fontWeight: 600
                }}>
                    {text}
                </Typography>

                {
                !hideDivider && <Divider orientation="vertical" sx={{
                    marginLeft: 'auto',
                    minHeight: '20px',
                }} /> 
                }

            </Stack>
        </TableCell>
    );

    
}
